import { useEffect, useState, useMemo } from "react";
import {motion} from 'framer-motion'
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import moment from "moment";
import { DatePicker ,Picker} from 'antd-mobile'
import * as echarts from "echarts";
import styles from "./index.module.scss";
import address from "../../images/consumptionflow/address.png";
import energy_icon from "../../images/consumptionflow/energy_icon.png";
import water_icon from "../../images/consumptionflow/water_icon.png";
import MyCharts from "../../component/Echarts/index";
import { getDayUseEnergyApi } from "../../http/request";
import { useStore, meterPorps } from "../../store/store";
import Empty from "../../component/empty/index";
import {useNavigate} from 'react-router-dom'
  const variants = {
    container: {
      animate: {
        transition: {
          staggerChildren: 0.1
        }
      }
    },
    card: {
      initial: {
        opacity: 0,
        x: -50
      },
  
      animate: {
        opacity: 1,
        x: 0
      }
    }
  };
export default function Home() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation();
  const [visible1, setVisible1] = useState(false)
  const [visible2, setVisible2] = useState(false)
  const {buildingName, meterList , buildingNameEN, buildingIsDisplayed,nkdSid} = useStore((state) => state);
  const [time, setTime] = useState<string>(moment().format('YYYY-MM'))
  const [list, setList] = useState([])
  const [monitorid, setMonitorId] = useState<string>('')
  const [meterOptions, setMeterOptions] = useState<meterPorps []>()
  const [meterName, setMeterName] = useState<string>('')
  /**
   * @description 获取用能记录
   */
  const getDayUseEnergy = async () => {
    const res = await getDayUseEnergyApi({
      row: 0,
page:1,
monitorid:monitorid,
startTime:moment(time).startOf('month').format('YYYY-MM-DD'),
endTime:moment(time).endOf('month').format('YYYY-MM-DD'),
    })
    if (res.data.code == 0) {
      setList(res.data.list)
    }
  }
  /**
   * @description 表计国际化
   * @param label 
   * @returns 
   */
  const coverMeterLabel = (label:string) => {
    let name = ''
    switch(label) {
      case '电表': name = t('EL')
      break;
      case '冷水表': name = t('LS')
      break
      case '热水表': name = t('RS')
      break;
      default: {}
    }
    return name
  }
  /**
   * @description 选择时间和表计类型后触发获取用能记录
   */
  useMemo(() => {
    if (!monitorid)return
    getDayUseEnergy()
  }, [monitorid, time])
  useEffect(() => {
    if (!nkdSid) {
      navigate('/login')
      return
    }
    document.title = t('XFLS')
    if (meterList.length> 0) {
      const options = meterList.map((item: Record<string, any>) => {
        return {value: item.monitorid, label:coverMeterLabel(item.energyType)}
      })
      setMonitorId(options[0].value)
      setMeterName(options[0].label)
      setMeterOptions([options])
    }
  }, [])
  /**
   * @description echarts 图表
   * @param list 
   * @returns 
   */
  const getOption = (list: Record<string, any>) => {
    const label: string[] = []
    const value: string [] = []
    list.forEach((item: Record<string, any>) => {
      label.push(item.clearingday.split('-')[2])
      value.push(item.clearingvalue)
    })
    const colorList = ["#FFFFFF", "#F3AC19", "#FF6379", "#F56948", "#9E87FF"];
    return {
      legend: {
        icon: "circle",
        top: i18n.language == "en" ? -4 : 0,
        itemWidth: 10,
        itemGap: i18n.language == "en" ? 5 : 20,
        textStyle: {
          fontSize: i18n.language == "en" ? 10 : 12,
          color: "#FFFFFF",
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          label: {
            show: true,
            backgroundColor: "#fff",
            color: "#556677",
            borderColor: "rgba(0,0,0,0)",
            shadowColor: "rgba(0,0,0,0)",
            shadowOffsetY: 0,
          },
          lineStyle: {
            width: 0,
          },
        },
        backgroundColor: "#fff",
        textStyle: {
          color: "#5c6c7c",
          fontSize: 12,
        },
        padding: [10, 10],
        extraCssText: "box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)",
      },
      grid: {
        top: 30,
        bottom: 26,
        left: 30,
        right: 30,
      },
      xAxis: [
        {
          type: "category",
          data: label,
          axisLine: {
            lineStyle: {
              color: "#CFD4E2",
              type: "dashed",
              opacity: 0.5,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              fontSize: 10,
              fontFamily: "Source Han Sans CN",
              fontWeight: 400,
              color: "#FFFFFF",
              opacity: 0.2,
            },
            // 默认x轴字体大小
            fontSize: 12,
            // margin:文字到x轴的距离
            margin: 10,
          },
          boundaryGap: false,
        },
      ],
      yAxis: [
        {
          type: "value",
          name: (meterName == "电表" || meterName == "Electric meter")? 'Kw/h': 'Cubic',
          nameTextStyle: {
            padding: [0,25,0,0],
            fontSize: 12,
            fontFamily: "Source Han Sans CN",
            fontWeight: 400,
            color: "#FFFFFF",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            margin: 8,
            textStyle: {
              fontSize: 10,
              fontFamily: "Source Han Sans CN",
              fontWeight: 400,
              color: "#FFFFFF",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#CFD4E2",
              type: "dashed",
              opacity: 0.5,
            },
          },
        },

      ],
      series: [
        {
          name: meterName,
          type: "line",
          data: value,
          yAxisIndex: 0,
          symbolSize: 1,
          symbol: "circle",
          smooth: true,
          showSymbol: false,
          lineStyle: {
            width: 3,
            color: "#F3AC19",
          },
          itemStyle: {
            normal: {
              color: colorList[1],
              borderColor: colorList[1],
            },
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#F3AC19",
                  },
                  {
                    offset: 1,
                    color: "#00AA90",
                  },
                ],
                false
              ),
            },
          },
        },
       /*  {
          name: t("SBYL2"),
          yAxisIndex: 1,
          type: "line",
          data: [15, 12, 17, 14, 10, 16, 11],
          symbolSize: 1,
          symbol: "circle",
          smooth: true,
          showSymbol: false,
          lineStyle: {
            width: 3,
            color: "#FF6379",
          },
          itemStyle: {
            normal: {
              color: colorList[2],
              borderColor: colorList[2],
            },
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "#FF6379",
                  },
                  {
                    offset: 1,
                    color: "#00AB8E",
                  },
                ],
                false
              ),
            },
          },
        }, */
      ],
    };
  };
    /**
   * @description echarts 图表
   */
    const echartsElement = useMemo(() => {
      return  <MyCharts id="chart" option={getOption(list)} /> 
    }, [list]) 
  return (
    <div className={styles.main_container}>
      <div className={styles.header_container}>
        <div className={styles.header_view}>
          <div className={styles.address_view}>
            <img src={address}  className={styles.address_icon} alt="" />
            <p>{i18n.language == 'en'? buildingNameEN: buildingName}</p>
            <div className={styles.select_energy_view}>
            <div className={styles.time_view}>
        <div
        className={styles.time}
          onClick={() => {
            setVisible1(true)
          }}
        >
          <p>{time} </p>
        </div>
        <DatePicker
          visible={visible1}
          cancelText={t('QX')}
          confirmText={t('QD')}
          onClose={() => {
            setVisible1(false)
          }}
          precision='month'
          onConfirm={val => {
            setTime(moment(val).format('YYYY-MM'))
          }}
        />
        </div>
        <div className={styles.time_view} style={{marginLeft: '2vw'}}>
        <div
        className={styles.time}
        onClick={() => {
          setVisible2(true)
        }}
      >
        <p>{meterName}</p>
      </div>
      <Picker
        columns={meterOptions as any []}
        visible={visible2}
        cancelText={t('QX')}
        confirmText={t('QD')}
        onClose={() => {
          setVisible2(false)
        }}
        value={['1']}
        onConfirm={(v:any) => {
          let val = v[0]
          const option = meterList.find((item: Record<string, any>) => item.monitorid == val)
          setMeterName(coverMeterLabel(option.energyType))
          setMonitorId(val)
        }}
      />
        </div>
            </div>
          </div>
          <div className={styles.echarts_view}>
           {  echartsElement }
          </div>
        </div>
      </div>
      <div className={styles.charge_list_container}>
        <div className={styles.header_view}>
          <div
            className={classNames(styles.title, {
              [styles.font_size12]: i18n.language == "en" ? true : false,
            })}
          >
            {t("RQ")}
          </div>
          {meterName == "电表" || meterName == "Electric meter" ? (
            <div
              className={classNames(styles.title, {
                [styles.font_size12]: i18n.language == "en" ? true : false,
              })}
            >
              {t("YDL")}(kw/h)
            </div>
          ) : (
            <div
              className={classNames(styles.title, {
                [styles.font_size12]: i18n.language == "en" ? true : false,
              })}
            >
              {t("YSL")}({t("LFM")})
            </div>
          )}
             {/* 金额先隐藏后续开放 */}
    {/*       <div
            className={classNames(styles.title, {
              [styles.font_size12]: i18n.language == "en" ? true : false,
            })}
          >
            {t("JE")}({t("MONETARY_UNIT")})
          </div> */}
        </div>
        <motion.div 
         initial="initial"
         animate="animate"
         variants={variants.container}
         className={styles.list_content}
        >
          {list.length >0? list.map((item: Record<string, any>) => {
            return  <motion.div className={styles.list_view} key={item.clearingday}  variants={variants.card}>
            <div className={styles.date}>{item.clearingday}</div>
            <div className={styles.energy_view}>
              {meterName == "电表" || meterName == "Electric meter"?
               <img src={energy_icon} style={{width:'45.5px', height:'23.5px'}} alt="" />:
               <img src={water_icon} style={{width:'25.5px', height:'23.5px'}} alt="" />
               }
              <p>{item.clearingvalue}</p>
            </div>
            {/* 金额先隐藏后续开放 */}
        {/*     <div className={styles.money_view}>
            <img src={money_icon} style={{width:'22.5px', height:'16px'}} alt="" />
              <p>{item.clearingmoney}</p>
            </div> */}
          </motion.div>
          }): <Empty description={t('ZWSJ')} />}
        </motion.div>
      </div>
    </div>
  );
}
